import React, { useState } from 'react'
import { StaticQuery, graphql } from 'gatsby'

import FramedLayout from './FramedLayout'
import { Engine, defaultState } from '~components/Search'
import { SearchProvider } from '~contexts/SearchContext'

import Microcopy from '~models/Microcopy'

const Layout = ({
  children,
  ...rest
}) => (
  <StaticQuery
    query={ query }
    render={data => {
      const microcopy = new Microcopy(data.microcopy)

      const state = useState(defaultState)
      const engine = new Engine({ microcopy, state })

      return (
        <SearchProvider engine={engine}>
          <FramedLayout microcopy={microcopy} {...rest}>
            {children}
          </FramedLayout>
        </SearchProvider>
      )
    }}
  />
)

const query = graphql`query {
  microcopy {
    code
    serialized
  }
}`

export default Layout